import { render } from "./CallInteractionHeader.vue?vue&type=template&id=47e1b7c7&scoped=true"
import script from "./CallInteractionHeader.vue?vue&type=script&lang=js"
export * from "./CallInteractionHeader.vue?vue&type=script&lang=js"

import "./CallInteractionHeader.vue?vue&type=style&index=0&id=47e1b7c7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e1b7c7"]])

export default __exports__